const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/sir-debug/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
interface SirDebugBeforeLoadArgs {
  context: {
    flags: Partial<FlagKeys>;
  };
  params: {
    org: string;
  };
}
export const sirDebugBeforeLoad = async ({
  context: {
    flags
  },
  params: {
    org
  }
}: SirDebugBeforeLoadArgs) => {
  if (!flags.sirDebugViewEnabled) {
    throw redirect({
      to: '/org/$org',
      params: {
        org
      },
      replace: true
    });
  }
};
export const Route = createFileRoute('/(app)/org/$org/sir-debug/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: sirDebugBeforeLoad
});